import { render, staticRenderFns } from "./businesses.vue?vue&type=template&id=557379a5"
import script from "./businesses.vue?vue&type=script&lang=js"
export * from "./businesses.vue?vue&type=script&lang=js"
import style0 from "./businesses.vue?vue&type=style&index=0&id=557379a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports